module.exports = __webpack_public_path__ + "static/media/home-heart.a7fb7102.svg";